import {
  faArrowRightFromBracket,
  faChartSimple,
  faChevronLeft
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  IonBackButton,
  IonBadge,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonItem,
  IonLabel,
  IonList,
  IonMenuButton,
  IonPage,
  IonProgressBar,
  IonRow,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import "./videos.scss";
import { useEffect, useState } from "react";
import Glide from "@glidejs/glide";
import coffeeTools from "../../CoffeeTools";
import lnbp_logo from "../../icon/icon.png";

import VideoComponent from "../../components/videos/video";

const Videos: React.FC = () => {
  const [showProgessBar, setShowProgessBar] = useState(true);
  const [videos, setVideos] = useState([]);
  let base_url = process.env.REACT_APP_BASE_URL;
  let coffee_tools = new coffeeTools();

  //declared outside to make it global and used it on the page

  useEffect(() => {
    // show slider
    //start the page
    mainController.init();
    let coffee = new coffeeTools();
    console.log(coffee.test(123));
  }, []);

  var controller = (() => {
    function getVideos() {
      // call the progress bar

      fetch(base_url + "/media/videos/filtered", {
        method: "Post",
        credentials: "omit",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          count: "10"
        })
      })
        .then((response) => response.json())
        .then((response) => {
          setVideos(response.items);
          console.log(response);
        });
    }
    return {
      getVideos: () => getVideos()
    };
  })();

  let view = (() => {
    let dom_obj = {};

    // tools and helpers
    function createSectionTitles(title, dom_obj_id) {
      let container = document.getElementById(dom_obj_id);
      container.innerHTML = "";
      coffee_tools.createSectionTitle(title, container);
    }

    return {
      createSectionTitles: (title, container) =>
        createSectionTitles(title, container)
    };
  })();

  var mainController = (function (page_controller, page_view) {
    var setupEventListeners = function () {};
    return {
      init: function () {
        console.log("Menu started");
        setupEventListeners();

        // get the videos
        controller.getVideos();

        // set title
        page_view.createSectionTitles("Últimos vídeos", "js__videos_title");

        setShowProgessBar(false);
      }
    };
  })(controller, view);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar
          className='home_toolbar'
          color={"secondary"}
        >
          <div hidden={!showProgessBar}>
            <IonProgressBar type='indeterminate'></IonProgressBar>
          </div>
          <IonButtons slot='start'>
            <IonMenuButton></IonMenuButton>
            <IonButton
              onClick={() => {
                window.history.back();
              }}
            >
              <FontAwesomeIcon
                size='lg'
                pull='left'
                icon={faChevronLeft}
              />
            </IonButton>
          </IonButtons>
          <div className='header_lnbp_icon'>
            <img
              src={lnbp_logo}
              alt='LNBP'
            />
          </div>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div id='js__videos_title'></div>
        <IonList>
          {videos.map((video) => (
            <IonItem
              key={video.id}
              style={{ "--border-color": "#fff", "margin-bottom": "0.5rem" }}
            >
              <VideoComponent video={video}></VideoComponent>
            </IonItem>
          ))}
        </IonList>
      </IonContent>
    </IonPage>
  );
};

export default Videos;
